/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @nx/enforce-module-boundaries */
'use client';

import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Grid,
  Paper,
  Avatar,
  Button,
  useTheme,
  Tabs,
  Tab,
  IconButton,
} from '@mui/material';
import {
  DirectionsCar,
  AccessTime,
  PauseCircle,
  LocationOn,
  Speed,
  SmokingRooms,
  Warning,
  Videocam,
  Bedtime,
  PlayArrow,
} from '@mui/icons-material';
import TripDetailMap from '../../../Trips/componenets/TripDetailMap';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { start } from 'repl';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import { set } from 'react-datepicker/dist/date_utils';
import RunningHistoryMap from './RunningHistoryMap';
import { warningIcons } from '../../../Alarm/Vehicle-Alerts/helper/warningIcons';
import Loader from 'packages/novous_web/src/common/components/Loader';
import { ClassNames } from '@emotion/react';
import axiosInstance from '../../../../../api/apiClient'
import LiveFeedModal from '../../../Reports/components/LiveFeed';

interface Alert {
  id: string;
  driverName: string;
  vehicleNumber: string;
  device_id: string;
  vehicleId: string;
  date_time: string;
  vehicleName: string;
  warningSortKey: string;
  videoUrls: string[];
  warningType: string;
  warningString: string;
  driverId: string;
  videoFileName: string;
  gpsSpeed: number;
  deviceType?: string;
  tripId: string;
}

interface AlertCounts {
  [key: string]: number;
}
interface TripSummaryData {
  vehicleId: string;
  totalDriveTime: number;
  totalIdleTime: number;
  totalStopTime: number;
  totalAlerts: number;
  startLocation: string | null;
  endLocation: string | null;
  alertCounts: AlertCounts;
  mapRenders: any;
}

type TripFilterTab = 'all' | 'movements' | 'stoppages' | 'alerts';

export default function TripSummaryDashboard({
  vehicleRegistrationNumber,
  historyDate,
  vehicleData,
}: {
  vehicleRegistrationNumber: string;
  historyDate: any;
  vehicleData?: any;
}) {
  const theme = useTheme();
  const { user } = useAuth();
  const { data, error, loading, fetchData } = useAxios<any>(
    API_ENDPOINTS.directories.VEHICLE_RUNNING_HISTORY,
    'POST',
  );
  const {
    data: summaryData,
    error: summaryDataError,
    loading: summaryDataLoading,
    fetchData: fetchSummaryData,
  } = useAxios<any>(API_ENDPOINTS.directories.VEHICLE_TRIP_SUMMARY, 'POST');
  const [tripSummaryData, setTripSummaryData] = useState<any>();
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState<any>(null);
  const [alertEvaluatedKey, setAlertEvaluatedKey] = useState<any>(null);
  const [lastProcessedData, setLastProcessedData] = useState<any>(null);
  const [tripHistory, setTripHistory] = useState<any>([]);
  const [filteredTripHistory, setFilteredTripHistory] = useState<any>([]);
  const [alertsData, setAlertsData] = useState<any>([]);
  const [selectedTrip, setSelectedTrip] = useState<any>(null); // Add this state
  const [activeTab, setActiveTab] = useState<TripFilterTab>('all');
  useEffect(() => {
    fetchData({
      fleetId: user.customer_id,
      lastEvaluatedKey: null,
      vehicleId: vehicleRegistrationNumber,
      startDate: `${historyDate.startDate}:${historyDate.startTime}`,
      endDate: `${historyDate.endDate}:${historyDate.endTime}`,
    });
  }, [user?.customer_id, historyDate, vehicleRegistrationNumber]);
  useEffect(() => {
    fetchSummaryData({
      fleetId: user.customer_id,
      lastEvaluatedKey: null,
      vehicleId: vehicleRegistrationNumber,
      startDate: `${historyDate.startDate}:${historyDate.startTime}`,
      endDate: `${historyDate.endDate}:${historyDate.endTime}`,
    });
  }, [user?.customer_id, historyDate, vehicleRegistrationNumber]);
  useEffect(() => {
    setSelectedTrip(null); // Reset selected trip when vehicleData changes
  }, [vehicleRegistrationNumber, historyDate]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [appendData, setAppendData] = useState<any>(false);

  useEffect(() => {
    if (!tripHistory) return;

    let filtered = tripHistory;

    switch (activeTab) {
      case 'movements':
        filtered = tripHistory.filter((trip: any) => trip.type === 'RUNNING');
        break;
      case 'stoppages':
        filtered = tripHistory.filter((trip: any) => trip.type === 'STOP' || trip.type === 'IDLE');
        break;
      case 'alerts':
        filtered = tripHistory;
        break;
      default:
        filtered = tripHistory;
    }

    setFilteredTripHistory(filtered);
  }, [activeTab, tripHistory]);
  const getColor = (status: string) => {
    switch (status) {
      case 'IDLE':
        return 'bg-amber-500';
      case 'RUNNING':
        return 'bg-green-500';
      case 'STOP':
        return 'bg-red-500';
      default:
        return theme.palette.grey[500];
    }
  };
  const getLineColor = (status: string) => {
    switch (status) {
      case 'IDLE':
        return 'bg-amber-300';
      case 'RUNNING':
        return 'bg-green-300';
      case 'STOP':
        return 'bg-red-300';
      case 'ALERT':
        return 'bg-red-300';
      default:
        return theme.palette.grey[500];
    }
  };
  const getTextColor = (status: string) => {
    switch (status) {
      case 'IDLE':
        return 'text-amber-500';
      case 'RUNNING':
        return 'text-green-500';
      case 'STOP':
        return 'text-red-500';
      case 'ALERT':
        return 'text-red-500';
      default:
        return theme.palette.grey[500];
    }
  };
  function capitalize(str: string) {
    if (!str) return '';
    const lower = str.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }
  function getTimeDifference(startDate: string, endDate: string): string {
    const parseCustomDate = (dateStr: string): Date | null => {
      const parts = dateStr.split(':');
      if (parts.length !== 4) return null;

      const [datePart, hours, minutes, seconds] = parts;
      const isoString = `${datePart}T${hours}:${minutes}:${seconds}`;
      const date = new Date(isoString);
      return isNaN(date.getTime()) ? null : date;
    };

    try {
      const start = parseCustomDate(startDate);
      const end = parseCustomDate(endDate);

      if (!start || !end) {
        throw new Error('Invalid date format');
      }

      const diffMs = end.getTime() - start.getTime();

      if (diffMs < 0) {
        return '0sec';
      }

      const diffSec = Math.floor(diffMs / 1000);
      const diffMin = Math.floor(diffSec / 60);
      const diffHr = Math.floor(diffMin / 60);

      const sec = diffSec % 60;
      const min = diffMin % 60;

      let result = '';
      if (diffHr > 0) result += `${diffHr}hr${diffHr !== 1 ? 's' : ''} `;
      if (min > 0) result += `${min}min `;
      if (sec > 0 || result === '') result += `${sec}sec`;

      return result.trim();
    } catch (error) {
      console.error('Error calculating time difference:', error);
      return '0sec';
    }
  }
  function formatTime(dateString: string): string {
    const date = new Date(dateString);

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${hours}:${formattedMinutes}${ampm}`;
  }
  useEffect(() => {
    if (data) {
      if (data?.data?.vehicleRunning) {
        const tripHistoryData = data?.data?.vehicleRunning?.map((trip: any) => ({
          startTime: formatTime(trip?.startDate),
          endTime: formatTime(trip?.endDate),
          startDate: trip.startDate, // Add startDate
          endDate: trip.endDate, // Add endDate
          duration: getTimeDifference(trip?.startDate, trip?.endDate),
          distance: trip?.distance,
          color: getColor(trip?.status),
          type: trip?.status,
          endLat: trip?.endLat,
          endLong: trip?.endLong,
          startLat: trip?.startLat,
          startLong: trip?.startLong,
        }));
        if (appendData) {
          setTripHistory((prevTripHistory: any) => {
            if (prevTripHistory.length === 0 || tripHistoryData.length === 0) {
              return [...prevTripHistory, ...tripHistoryData];
            }
            const lastPrevRecord = prevTripHistory[prevTripHistory.length - 1];
            const firstNewRecord = tripHistoryData[0];
            if (lastPrevRecord.status === firstNewRecord.status) {
              return [...prevTripHistory.slice(0, -1), ...tripHistoryData];
            }
            return [...prevTripHistory, ...tripHistoryData];
          });
        } else {
          setTripHistory(tripHistoryData);
        }
        setLastEvaluatedKey(data?.data?.lastEvaluatedKey);
        setLastProcessedData(data?.data?.lastProcessData);
        setAppendData(false);
      } else {
        setTripHistory([]);
        setLastEvaluatedKey(null);
        setLastProcessedData(null);
        setAppendData(false);
      }
    }
  }, [data]);

  useEffect(() => {
    if (summaryData) {
      setTripSummaryData(summaryData?.data);
      if (summaryData?.data?.totalAlerts) {
        const warningIconMap = Object.fromEntries(
          warningIcons.map((item: any) => [item.warningName, item.iconName]),
        );
        const alertsData = {
          alerts: {
            categories: Object.entries(summaryData?.data?.alertCounts).map(([name, count]) => ({
              id: name,
              name,
              count,
              icon: warningIconMap[name] || null,
              color: '#EEEDFC',
            })),
          },
        };
        setAlertsData(alertsData);
      }
    }
  }, [summaryData]);
  const fetchMoreRecords = () => {
    setAppendData(true);
    fetchData({
      fleetId: user.customer_id,
      lastEvaluatedKey: lastEvaluatedKey,
      vehicleId: vehicleRegistrationNumber,
      startDate: `${historyDate.startDate}:${historyDate.startTime}:00`,
      endDate: `${historyDate.endDate}:${historyDate.endTime}:00`,
      lastProcessData: lastProcessedData,
    });
  };
  const fetchMoreAlertRecords = () => {
    setAppendAlertData(true);
    fetchalertMapPoints({
      fleetId: user.customer_id,
      vehicleId: vehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
      startDate: `${historyDate.startDate}:${historyDate.startTime}`,
      endDate: `${historyDate.endDate}:${historyDate.endTime}`,
      alertEvaluatedKey: alertEvaluatedKey,
    });
  };
  function formatDuration(seconds: any) {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts = [];
    if (hrs > 0) parts.push(`${hrs} hour${hrs > 1 ? 's' : ''}`);
    if (mins > 0) parts.push(`${mins} minute${mins > 1 ? 's' : ''}`);
    if (secs > 0 || parts.length === 0) parts.push(`${secs} second${secs > 1 ? 's' : ''}`);

    return parts.join(' ');
  }
  console.log('vechileDataXYZ', vehicleData);

  function get12HourTime(dateTimeString: string) {
    const parts = dateTimeString.split(':');

    if (parts.length < 4) {
      return 'Invalid datetime format';
    }

    let hours = parseInt(parts[1], 10);
    const minutes = parts[2];
    const seconds = parts[3];

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return `${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
  }

  function getFormattedDate(dateTimeString: string) {
    const parts = dateTimeString.split(':');

    if (parts.length < 4) {
      return 'Invalid datetime format';
    }

    const datePart = parts[0]; // "2025-06-23"
    const [year, month, day] = datePart.split('-');

    const monthNames = [
      'Jan.',
      'Feb.',
      'Mar.',
      'Apr.',
      'May.',
      'Jun.',
      'Jul.',
      'Aug.',
      'Sep.',
      'Oct.',
      'Nov.',
      'Dec.',
    ];

    const monthName = monthNames[parseInt(month, 10) - 1];

    return `${day} ${monthName} ${year}`;
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: TripFilterTab) => {
    setActiveTab(newValue);
  };

  const [appendAlertData, setAppendAlertData] = useState<boolean>(false);
  const [alertDetailsData, setAlertDetailsData] = useState<any>([]);

  const {
    data: alertMapPoints,
    loading: loadingalertMapPoints,
    fetchData: fetchalertMapPoints,
  } = useAxios<any>(API_ENDPOINTS.directories.GET_VEHICLE_RUNNING_MAP_ALERTS, 'POST');

  useEffect(() => {
    fetchalertMapPoints({
      fleetId: user?.customer_id,
      vehicleId: vehicleData?.vehicleRegistrationNo || vehicleData?.vehicleRegistrationNo,
      startDate: `${historyDate.startDate}:${historyDate.startTime}`,
      endDate: `${historyDate.endDate}:${historyDate.endTime}`,
      //lastEvaluatedKey: null,
      alertEvaluatedKey: alertEvaluatedKey,
    });
  }, [historyDate, vehicleData, user?.customer_id]);

  useEffect(() => {
    if (appendAlertData) {
      if (alertMapPoints?.data?.mapRenderList && alertDetailsData.length > 0) {
        setAlertDetailsData((prevData: any) => {
          return prevData.concat(alertMapPoints?.data?.mapRenderList);
        });
        setAlertEvaluatedKey(alertMapPoints?.data?.alertEvaluatedKey);
      }
      setAppendAlertData(false);
    } else {
      setAlertDetailsData(alertMapPoints?.data?.mapRenderList || []);
      setAlertEvaluatedKey(alertMapPoints?.data?.alertEvaluatedKey);
    }
  }, [alertMapPoints]);

  const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({
    isOpen: false,
    tripId: '',
    vehicleId: '',
    deviceId: '',
    warningSortKey: '',
    deviceType: '',
  });
  const [liveFeedCameraInfo, setLiveFeedCameraInfo] = useState<any[]>([]);

  const [selected, setSelected] = useState(2);

  const handleLiveFeedClose = () => {
    setIsLiveFeedOpen({
      isOpen: false,
      tripId: '',
      vehicleId: '',
      deviceId: '',
      warningSortKey: '',
      deviceType: '',
    });
    setSelected(2);
  };
  const [isCheckingVideos, setIsCheckingVideos] = useState(false);

  const handleOpenLiveFeed = async (
    vehicleId: string,
    // videoUrls: string[],
    warningSortKey: string,
    warningType: string,
    videoFileName: string,
    deviceId: string,
    cameraKey?: string,
    deviceType?: string,
    alertobj?: Alert,
  ) => {
    setIsLiveFeedOpen({
      isOpen: true,
      tripId: alertobj?.tripId || '', // <-- Use tripId from alertobj
      vehicleId: vehicleId,
      deviceId: deviceId,
      warningSortKey: warningSortKey,
      deviceType: deviceType || '',
    });
    // console.log('videoUrls', videoUrls);
    setIsCheckingVideos(true); // Start checking

    if (!videoFileName) {
      console.log('No video file name available');
      setLiveFeedCameraInfo([]);
      setIsCheckingVideos(false);
      return;
    }

    try {
      const response = await axiosInstance({
        url: API_ENDPOINTS.alarm.ALERTS_VIDE0_URL_SECONDARY,
        method: 'POST',
        data: {
          vehicleId: vehicleId,
          timestamp: warningSortKey,
          alertType: warningType,
          fileNames: videoFileName,
        },
        responseType: 'json',
      });

      console.log('newVideoURLS', response.data.data);

      const videoUrlsFromApi = Array.isArray(response.data.data) ? response.data.data : [];

      const cameraInfo = videoUrlsFromApi.map((url: string) => {
        const fileName = url.split('/').pop()?.split('?')[0] || '';
        const segments = fileName.split('_');
        const cameraCode = segments[1] || 'Unknown';
        const cameraMapping: Record<string, string> = {
          '01': 'ADAS',
          '02': 'CAM3',
          '03': 'CAM4',
          '04': 'DMS',
        };
        const arr = Object.entries(cameraMapping);
        const ck =
          cameraKey === 'FCW'
            ? 'ADAS'
            : cameraKey === 'DSM'
              ? 'CAM3'
              : cameraKey === 'REAR_CAMERA'
                ? 'CAM4'
                : cameraKey === 'IN_CABIN'
                  ? 'DMS'
                  : cameraKey;

        const cameraName = cameraMapping[cameraCode] || 'Unknown';
        //  const cameraId = cameraMapping[cameraCode] || "Unknown";
        return { cameraId: cameraCode, cameraName, playBackUrl: url };
      });

      setLiveFeedCameraInfo(cameraInfo);
      setSelected(0);
    } catch (error) {
      console.error('Error fetching video URLs:', error);
      setLiveFeedCameraInfo([]);
      setIsCheckingVideos(false);
    }
  }

  console.log(isLiveFeedOpen, 'isLiveFeedOpen');

  return (
    <>
      {summaryDataLoading && <Loader />}
      <div className="flex flex-col lg:flex-row gap-6 h-[calc(100vh-120px)]">
        {/* Left Section - Trip Data (Scrollable) */}
        <div className="w-full lg:w-1/2 overflow-y-auto pr-2 py-4 border border-gray-200 rounded-xl bg-white">
          <Card sx={{ mb: 6 }} className="border border-gray-200 rounded-xl bg-white">
            <CardContent
              sx={{
                '&:last-child': {
                  pb: 4, // Override Material-UI's last-child padding behavior
                },
              }}
            >
              {/* Header */}
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'bold',
                  mb: 2,
                  color: 'text.primary',
                }}
              >
                Summary
              </Typography>

              {/* Vehicle Info Section */}
              <Grid container>
                {/* Left Column */}
                <Grid item xs={12} md={6}>
                  {/* Registration Number */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'end' }}>
                      <DirectionsCar sx={{ mr: 0.5, color: 'text.secondary' }} />
                      <Typography variant="body2" color="secondary" fontWeight={400} fontSize={16}>
                        Vehicle Registration number
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 4 }}>
                      {tripSummaryData?.vehicleId}
                    </Typography>
                  </Box>

                  {/* Idle Time */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'end' }}>
                      <AccessTime sx={{ mr: 0.5, color: 'text.secondary' }} />
                      <Typography variant="body2" color="secondary" fontWeight={400} fontSize={16}>
                        Total Idle Time
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 4 }}>
                      {formatDuration(tripSummaryData?.totalIdleTime)}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'end' }}>
                      <LocationOn sx={{ mr: 0.5, color: 'text.secondary' }} />
                      <Typography variant="body2" color="secondary" fontWeight={400} fontSize={16}>
                        Total Distance
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 4 }}>
                      {tripSummaryData?.totalDistance
                        ? `${tripSummaryData?.totalDistance.toFixed(2)} km`
                        : '0 km'}
                    </Typography>
                  </Box>
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} md={6}>
                  {/* Drive Time */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'end' }}>
                      <AccessTime sx={{ mr: 0.5, color: 'text.secondary' }} />
                      <Typography variant="body2" color="secondary" fontWeight={400} fontSize={16}>
                        Total Drive Time
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 4 }}>
                      {formatDuration(tripSummaryData?.totalDriveTime)}
                    </Typography>
                  </Box>

                  {/* Stop Time */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'end' }}>
                      <PauseCircle sx={{ mr: 0.5, color: 'text.secondary' }} />
                      <Typography variant="body2" color="secondary" fontWeight={400} fontSize={16}>
                        Total Stop Time
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 4 }}>
                      {formatDuration(tripSummaryData?.totalStopTime)}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              {/* Locations Section - Now stacked vertically */}
              <Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'end' }}>
                    <LocationOn sx={{ mr: 0.5, color: 'text.secondary' }} />
                    <Typography variant="body2" color="secondary" fontWeight={400} fontSize={16}>
                      Start Location
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 4 }}>
                    {tripSummaryData?.startLocation}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'end' }}>
                    <LocationOn sx={{ mr: 0.5, color: 'text.secondary' }} />
                    <Typography variant="body2" color="secondary" fontWeight={400} fontSize={16}>
                      End Location
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 4 }}>
                    {tripSummaryData?.endLocation}
                  </Typography>
                </Box>
              </Box>

              {/* Alerts Section */}
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 3 }}>
                  Alert Count: <span style={{ color: 'red' }}>({tripSummaryData?.totalAlerts || 0})</span>
                </Typography>

                {tripSummaryData?.totalAlerts > 0 ? (
                  <Grid container spacing={2}>
                    {alertsData?.alerts?.categories?.map((alert: any) => (
                      <Grid item xs={6} key={alert.id}>
                        <Box
                          sx={{
                            width: '100%',
                            height: 48,
                            borderRadius: '12px',
                            padding: '12px 16px',
                            background: alert.color,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <img src={alert.icon} alt={alert.name} className="w-6 h-6 mr-2" />
                          <Typography sx={{ flexGrow: 1 }}>{alert.name}</Typography>
                          <Typography sx={{ fontWeight: 'bold' }}>{alert.count}</Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Typography variant="body2" sx={{ color: 'gray', mt: 1 }}>
                    No alerts to display.
                  </Typography>
                )}
              </Box>
            </CardContent>
          </Card>

          <Card className="shadow-md mt-6">
            <CardContent className="p-5 py-6">
              <Typography variant="h6" className="font-bold mb-6">
                Trip Running History
              </Typography>

              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  aria-label="trip history tabs"
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{
                    flexShrink: 0, // Prevent shrinking
                    borderRadius: '8px',
                    width: 'fit-content',
                    padding: '4px',
                    backgroundColor: theme.palette.selected,
                    '& .MuiTab-root': { color: 'black !important' },
                  }}
                >
                  <Tab
                    label="All"
                    value="all"
                    sx={{
                      ...(activeTab === 'all' && {
                        backgroundColor: theme.palette.background.default,
                        borderRadius: '8px',
                        fontWeight: 600,
                        padding: '8px 16px',
                        boxShadow: '0px 4px 6px #5547DD1A',
                      }),
                    }}
                  />
                  <Tab
                    label="Movements"
                    value="movements"
                    sx={{
                      ...(activeTab === 'movements' && {
                        backgroundColor: theme.palette.background.default,
                        borderRadius: '8px',
                        fontWeight: 600,
                        padding: '8px 16px',
                        boxShadow: '0px 4px 6px #5547DD1A',
                      }),
                    }}
                  />
                  <Tab
                    label="Stoppages"
                    value="stoppages"
                    sx={{
                      ...(activeTab === 'stoppages' && {
                        backgroundColor: theme.palette.background.default,
                        borderRadius: '8px',
                        fontWeight: 600,
                        padding: '8px 16px',
                        boxShadow: '0px 4px 6px #5547DD1A',
                      }),
                    }}
                  />
                  <Tab
                    label="Alerts"
                    value="alerts"
                    sx={{
                      ...(activeTab === 'alerts' && {
                        backgroundColor: theme.palette.background.default,
                        borderRadius: '8px',
                        fontWeight: 600,
                        padding: '8px 16px',
                        boxShadow: '0px 4px 6px #5547DD1A',
                      }),
                    }}
                  />
                </Tabs>
              </Box>

              {activeTab === 'alerts' ? (
                <Box sx={{ mt: 3 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Alerts History
                  </Typography>

                  {alertDetailsData?.length > 0 ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      {alertDetailsData
                        .slice()
                        .reverse()
                        .map((alert: any) => (
                          console.log(alert, 'alertDetailsData'),
                          <Box className="flex flex-row items-center gap-8" key={alert.id}>
                            <Box className="w-16 flex flex-col items-center gap-2" style={{ flex: 0.15 }}>
                              <Typography variant="body2">{get12HourTime(alert.timeStamp)}</Typography>
                              <Typography
                                variant="body2"
                                className={`${getLineColor(alert.type)} ${getTextColor(alert.type)}`}
                                sx={{
                                  fontWeight: 'light',
                                  lineHeight: '24px',
                                  borderRadius: '8px',
                                  paddingLeft: '8px',
                                  paddingRight: '8px',
                                  height: '24px',
                                }}
                              >
                                {alert.type.toUpperCase()}
                              </Typography>
                            </Box>
                            <Box className={`w-3 h-3 rounded-full z-10 ${getLineColor(alert.type)}`}></Box>
                            <Paper
                              className="p-4 bg-gray-50 border border-gray-200 flex w-full"
                              sx={{
                                borderRadius: '12px',
                                cursor: 'pointer', // Add a pointer cursor for better UX
                              }}
                            >
                              <Box className="flex w-full">
                                <Typography variant="body2" color="secondary" fontWeight={400} fontSize={16}>
                                  <b>Alert Type:</b> {alert.alertName}
                                </Typography>
                              </Box>
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <IconButton
                                  size="small"
                                  sx={{ color: '#5547DD', p: 0 }}
                                  onClick={() =>
                                    handleOpenLiveFeed(
                                      vehicleData.vehicleRegistrationNo,
                                      // alert.videoUrls,
                                      alert.timeStamp,
                                      alert.alertName,
                                      alert.fileNames,
                                      vehicleData.deviceId,
                                      vehicleData.deviceType,
                                      vehicleData.deviceType,
                                    )
                                  }
                                >
                                  <PlayArrow fontSize="medium" />
                                </IconButton>
                              </Box>
                            </Paper>
                          </Box>
                        ))}
                      {alertEvaluatedKey !== null && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>
                          <Button onClick={fetchMoreAlertRecords}>View More</Button>
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      No alerts recorded during this time period.
                    </Typography>
                  )}
                </Box>
              ) : (
                <>
                  {filteredTripHistory.length === 0 && !loading ? (
                    <Typography variant="body2" className="text-gray-500">
                      No {activeTab === 'all' ? 'trip history' : activeTab} available for the selected date
                      range.
                    </Typography>
                  ) : loading ? (
                    <Loader />
                  ) : null}
                  <Box className="relative py-2">
                    {filteredTripHistory.map(
                      (entry: any, index: any) => (
                        // {tripHistory.map((entry: any, index: any) => (
                        console.log('entryData', entry),
                        (
                          <React.Fragment key={index}>
                            <Box className="flex items-center mb-6">
                              <Box className="w-16 flex flex-col items-center gap-2" style={{ flex: 0.15 }}>
                                <Typography variant="body2">{get12HourTime(entry.startDate)}</Typography>
                                <Typography
                                  variant="body2"
                                  className={`${getLineColor(entry.type)} ${getTextColor(entry.type)}`}
                                  sx={{
                                    fontWeight: 'light',
                                    lineHeight: '24px',
                                    borderRadius: '8px',
                                    paddingLeft: '8px',
                                    paddingRight: '8px',
                                    height: '24px',
                                  }}
                                >
                                  {entry.type}
                                </Typography>
                                <Typography variant="body2">{get12HourTime(entry.endDate)}</Typography>
                              </Box>

                              <Box className="relative flex flex-col items-center mx-3 pt-1">
                                <Box className={`w-3 h-3 rounded-full z-10 ${getLineColor(entry.type)}`} />
                                {index < tripHistory.length && (
                                  <Box className={`w-0.5 h-16 my-1 ${getLineColor(entry.type)}`} />
                                )}
                                <Box className={`w-3 h-3 rounded-full z-10 ${getLineColor(entry.type)}`} />
                              </Box>

                              <Box
                                className="flex-1"
                                onClick={() => {
                                  setSelectedTrip(entry);
                                }} // Add this line
                              >
                                <Paper
                                  className="p-4 bg-gray-50 border border-gray-200"
                                  sx={{
                                    borderRadius: '12px',
                                    cursor: 'pointer', // Add a pointer cursor for better UX
                                  }}
                                >
                                  <Box className="flex flex-col justify-between text-sm">
                                    <Box className="flex items-center font-light text-[#767676]">
                                      {`${capitalize(entry.type)} Time :`}
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontWeight: 'light',
                                          borderRadius: '8px',
                                          marginLeft: '8px',
                                          color: '#1B1B1B',
                                        }}
                                      >
                                        {entry.duration}
                                      </Typography>
                                    </Box>
                                    <Box className="flex items-center font-light text-[#767676]">
                                      Distance Covered :
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontWeight: 'light',
                                          borderRadius: '8px',
                                          marginLeft: '8px',
                                          color: '#1B1B1B',
                                        }}
                                      >
                                        {entry?.distance.toFixed(2)} km
                                      </Typography>
                                    </Box>
                                    <Box className="flex items-center font-light text-[#767676]">
                                      Date :
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontWeight: 'light',
                                          borderRadius: '8px',
                                          marginLeft: '8px',
                                          color: '#1B1B1B',
                                        }}
                                      >
                                        {getFormattedDate(entry?.startDate)}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Paper>
                              </Box>
                            </Box>
                          </React.Fragment>
                        )
                      ),
                    )}
                    {lastEvaluatedKey !== null && <Button onClick={fetchMoreRecords}> View More</Button>}
                  </Box>
                </>
              )}
            </CardContent>
          </Card>
        </div>

        <LiveFeedModal
          type="alert"
          alertName="Alert Evidence"
          selectedCamera={selected}
          trip={isLiveFeedOpen}
          cameraInfo={liveFeedCameraInfo}
          isDash={true}
          open={isLiveFeedOpen.isOpen}
          onClose={handleLiveFeedClose}
          deviceId={isLiveFeedOpen.deviceId}
          isCheckingVideos={isCheckingVideos}
        />

        <Paper elevation={1} className="w-full lg:w-1/2 p-4 rounded-md">
          <RunningHistoryMap
            stopsData={tripSummaryData?.mapRenders || []}
            startDate={`${historyDate.startDate}:${historyDate.startTime}`}
            endDate={`${historyDate.endDate}:${historyDate.endTime}`}
            selectedTrip={selectedTrip}
            clearTrip={() => setSelectedTrip(null)} // Clear selected trip
            selectedvehicleData={vehicleData} // Now includes startDate/endDate
          //alertIcons={alertsData?.alerts?.categories?.map((alert: any) => alert.icon)} // Pass alert icons
          />
        </Paper>
      </div>
    </>
  );
}
